import { patientOrganizationMoreOptions } from "../../patientOrganization.constant";

export const patientOrgMobileMoreOptions = [
  { val: "requestResearch", text: "Request Info" },
  { val: "engagement", text: "Engagement" },
  { val: "newProject", text: "New project" },
  ...patientOrganizationMoreOptions,
]
